import { render, staticRenderFns } from "./TransportForm.vue?vue&type=template&id=a46ad432&scoped=true&"
import script from "./TransportForm.vue?vue&type=script&lang=js&"
export * from "./TransportForm.vue?vue&type=script&lang=js&"
import style0 from "./TransportForm.vue?vue&type=style&index=0&id=a46ad432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46ad432",
  null
  
)

component.options.__file = "TransportForm.vue"
export default component.exports